import React, { useEffect, useState } from 'react';
import { ChartBarIcon, CurrencyDollarIcon, PresentationChartBarIcon } from '@heroicons/react/24/solid';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminLayout from '../AdminLayout';
import GraphAnalysis from './GraphAnalysis';
import OrderCountAnalysis from './OrderCountAnalysis';
import OrderFigureAnalysis from './OrderFigureAnalysis';



const ViewAnalysis = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeView, setActiveView] = useState('orders');

  const viewMeta = {
    orders: {
      activeItemId: 'order-analytics',
      title: 'Order Analytics',
      subtitle: 'Track order counts across overall, daily, weekly, and monthly timeframes.',
    },
    revenue: {
      activeItemId: 'revenue-analytics',
      title: 'Revenue Analytics',
      subtitle: 'Track revenue across overall, daily, weekly, and monthly timeframes.',
    },
    performance: {
      activeItemId: 'performance-overview',
      title: 'Performance Overview',
      subtitle: 'View trends and performance analytics.',
    },
  };

  useEffect(() => {
    const nextView = location.state?.analysisView;

    if (nextView) {
      setActiveView(nextView);
      return;
    }

    setActiveView('orders');
  }, [location.state]);


  const handleViewChange = (nextView) => {
    if (nextView === activeView) {
      return;
    }

    setActiveView(nextView);
    navigate('/view-analysis', {
      replace: true,
      state: { analysisView: nextView },
    });
  };

  const renderContent = () => {
    if (activeView === 'revenue') {
      return <OrderFigureAnalysis />;
    }

    if (activeView === 'performance') {
      return <GraphAnalysis />;
    }

    return <OrderCountAnalysis />;
  };

  return (
    <AdminLayout
      activeItemId={viewMeta[activeView]?.activeItemId}
      title={viewMeta[activeView]?.title || 'Model Report Analysis'}
      subtitle={viewMeta[activeView]?.subtitle || 'Use the analysis workspace to switch between order volume, revenue, and performance insights.'}
      contentClassName="mx-auto max-w-7xl"
      footerContainerClassName="mt-0"
    >
      {renderContent()}
    </AdminLayout>
  );
};

export default ViewAnalysis; 
 
